export default {
  mailTemplates: []
}
